import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/dedupe';
import './stylesheets/Button.scss';
import Icon from './Icon';

const renderIcon = (icon) => {
  if (icon) {
    return (<Icon className="button-icon" icon={icon} />);
  }
  return null;
};

export default function Button(props) {
  const { label, className, size, type: locType, icon, children, buttonType, ...others } = props;

  const classes = {
    Button: true,
    loc: true,
    'Button--primary': locType === 'primary',
    'Button--new': locType === 'new',
    'Button--test': locType === 'test',
    'Button--danger': locType === 'danger',
    'Button--small': size === 'small',
    [`Button__icon-${icon}`]: typeof icon !== 'undefined'
  };

  const flattenedClassNames = classNames(classes, className);
  const buttonAttr = {
    ...others,
    ...(buttonType && { type: buttonType })
  };

  return (
    <button {...buttonAttr} className={flattenedClassNames}>
      { renderIcon(icon) }
      { label }
      { children }
    </button>
  );
}

Button.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.string,
  type: PropTypes.string,
  icon: PropTypes.string,
  children: PropTypes.node,
  buttonType: PropTypes.string
};



// WEBPACK FOOTER //
// ./node_modules/@localytics/loc-components/lib/Button.jsx